import EA from 'helpers/init';

export default EA.Methods.mobileMenu = ($this) => {
    const nav = document.querySelector('.mobile-menu-wrap');
    const header = document.querySelector('.header');
    const search = document.querySelector('.search-wrap');
    const searchHeader = document.querySelector('.search-down-wrap');
    const overlay = document.querySelector('.overlay-header');
    const burger = $this;

    burger.addEventListener('click', () => {
        burger.classList.toggle('active');
        nav.classList.toggle('active');
        document.body.classList.toggle('overflow');
        document.body.classList.remove('overflow-2');
        searchHeader.classList.remove('active');
        headerCheck();
    });

    overlay.addEventListener('click', () => {
        document.body.classList.remove('overflow');
        document.body.classList.remove('overflow-2');
        searchHeader.classList.remove('active');
        burger.classList.remove('active');
        nav.classList.remove('active');
        headerCheck();
    });

    search.addEventListener('click', () => {
        searchHeader.classList.toggle('active');
        burger.classList.remove('active');
        document.body.classList.remove('overflow');
        document.body.classList.toggle('overflow-2');
        nav.classList.remove('active');
        headerCheck();
    });

    function headerCheck() {
        if (document.body.classList.contains('overflow-2') && header.classList.contains('active')) {
            header.classList.remove('active');
        } else if (document.body.classList.contains('overflow') && !header.classList.contains('active') && !document.body.classList.contains('header-sticky')) {
            header.classList.add('active');
        } else if (!header.classList.contains('active') && !document.body.classList.contains('header-sticky')) {
            header.classList.add('active');
        }
    };

    document.addEventListener('keydown', function (event) {
        const key = event.key;
        if (key === "Escape" && document.body.classList.contains('overflow')) {
            document.body.classList.remove('overflow');
            document.body.classList.remove('overflow-2');
            searchHeader.classList.remove('active');
            burger.classList.remove('active');
            nav.classList.remove('active');
            headerCheck();
        } else if (key === "Escape" && document.body.classList.contains('overflow-2')) {
            document.body.classList.remove('overflow');
            document.body.classList.remove('overflow-2');
            searchHeader.classList.remove('active');
            burger.classList.remove('active');
            nav.classList.remove('active');
            headerCheck();
        }
    });
}

